/*
 * Copyright © 2023-2024 www.4bex.com
 *
 * Licensed under the www.4bex.com License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.4bex.com/license
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useMutation } from "@tanstack/react-query";
import { axiosPrivate } from "../../configs/axios";
import { API_URLS } from "../../configs/api.urls";

export const sendAuthCodeToBackend = async (code) => {
   const response = await axiosPrivate({
      url: API_URLS.GOOGLE_LOGIN_URL,
      method: "POST",
      data: { code },
   });
   return response.data;
};

export const useGoogleAuthMutation = () => {
   return useMutation({
      mutationKey: ["googleAuth"],
      mutationFn: sendAuthCodeToBackend,
   });
};
